var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGmailOutline = function SvgGmailOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 17.171 13.58"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.386.6h12.4a1.553 1.553 0 0 1 1.55 1.547v9.285a1.553 1.553 0 0 1-1.55 1.547h-12.4a1.553 1.553 0 0 1-1.55-1.547V2.147A1.553 1.553 0 0 1 2.386.6",
    "data-name": "Path 18718"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.336 2.147-7.75 5.416-7.75-5.416",
    "data-name": "Path 18719"
  }))));
};
export default SvgGmailOutline;